import { Component } from "@angular/core";




import * as $ from 'jquery';
export class BaseHtmlHelperComponent {

  dialogType: string = ''
  dialogMessage: string = '';
  isErrorDialog: boolean = false;
  jquery: $;

  constructor() {
    this.jquery = $;
  }

  emitDisplayLoadingDialog(display: boolean) {
    if (display) {
      $("#loadingOverlay").removeClass('mb-loading-hide');
    }
    else {
      $("#loadingOverlay").addClass('mb-loading-hide');
    }
  }

  showAlertBox(message: string, type: number) {
    var prefix = '';
    $("#mbalertbox").removeClass();
    switch (type) {
      case 1: {
        prefix = "<span>Info</span> - ";
        $("#mbalertbox").addClass('alert-box-info');
      }
      case 2: {
        prefix = "<span>Warning</span> - ";
        $("#mbalertbox").addClass('alert-box-warning');
      }
      case 3: {
        prefix = "<span>Error</span> - ";
        $("#mbalertbox").addClass('alert-box-error');
      }
    }

    $("#mbalertbox").html(prefix + message);
    $("#mbalertbox").addClass('mb-alert-box');
  }

  hideMessageBox() {
    $(".mb-alert-box").addClass('alert-box-hide');
  }

  showDialog(msg: string, isError: boolean) {

    $("#messagemodal-text").text(msg);          //set message
    $("#messagemodal-type").removeClass();      //remove all css styles
    $("#messagemodal-icon").removeClass();      //remove all css styles

    if (isError) {
      $("#messagemodal-type").addClass('notice-error-box');
      $("#messagemodal-icon").addClass('glyphicon glyphicon-remove-sign');
      $("#messagemodal-title").text('ERROR');
    }
    else {
      $("#messagemodal-type").addClass('notice-success-box');
      $("#messagemodal-icon").addClass('glyphicon glyphicon-ok-sign');
      $("#messagemodal-title").text('SUCCESS');
    }

    $("#messagemodalbtn").click();
  }

  onNavigating() {
    this.emitDisplayLoadingDialog(true);
  }

}
